import {
  PasswordUpdateRequest,
  PasswordUpdateResponse,
} from "./passwordReset-models";
import { SIMPLE_PAYMENTS_SERVICE_GW_PREFIX } from "../constants";
import { createApiClientWithArgs } from "cy-fetch/lib/client";

export * from "./passwordReset-models";

export const passwordUpdateUrl = `${SIMPLE_PAYMENTS_SERVICE_GW_PREFIX}/api/v1/simple_payments/customers/update_password`;

export const passwordUpdateClient = createApiClientWithArgs({
  zod: PasswordUpdateResponse,
  argsFn: (args: PasswordUpdateRequest) => {
    return {
      url: passwordUpdateUrl,
      options: {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(args),
      },
    };
  },
});
